import { render, staticRenderFns } from "./dynamics.vue?vue&type=template&id=4a53a50a&scoped=true&"
import script from "./dynamics.vue?vue&type=script&lang=js&"
export * from "./dynamics.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=4a53a50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53a50a",
  null
  
)

export default component.exports